export default __webpack_public_path__ + "static/media/AdobeStock_281017898.b860ed71.jpeg";